var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"contenteditable":"false"}},[_c('iframe',{attrs:{"src":_vm.src,"width":"100%","height":"100%","contenteditable":"false"}}),_c('div',{staticClass:"drag"},[_c('icon',{attrs:{"name":"move"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }